import { format } from "date-fns";

import axiosClient from "../apiClient";
import { DATE_FORMAT } from "../utils/appConstants";
import { formatQueryArrayParam } from "../utils/utils";

export const AdCopiesService = async (params: Record<string, any>) => {
  try {
    if (params.start_date && params.end_date) {
      params.start_date = format(params.start_date, DATE_FORMAT);
      params.end_date = format(params.end_date, DATE_FORMAT);
    }

    const cleanedParams: Record<string, any> = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        if (
          ![
            "platform",
            "status",
            "indications",
            "campaign_id",
            "selectedMetrics",
            "creative_type",
          ].includes(key)
        ) {
          cleanedParams[key] = value;
        }
      }
    });

    let campaignQuery = "";
    if (params.campaign_id?.length) {
      campaignQuery = formatQueryArrayParam("campaign_id", params.campaign_id);
    }

    let providerQuery = "";
    if (params.platform?.some((item: string) => item && item?.trim() !== "")) {
      providerQuery = formatQueryArrayParam("provider", params.platform);
    }

    let statusQuery = "";
    if (params.status?.some((item: string) => item && item?.trim() !== "")) {
      statusQuery = formatQueryArrayParam("status", params.status);
    }

    let indicationQuery = "";
    if (
      params.indications?.some((item: string) => item && item?.trim() !== "")
    ) {
      indicationQuery = formatQueryArrayParam(
        "indications",
        params.indications
      );
    }
    let creativeTypeQuery = "";
    if (
      params.creative_type?.some((item: string) => item && item?.trim() !== "")
    ) {
      creativeTypeQuery = formatQueryArrayParam(
        "creative_type",
        params.creative_type
      );
    }
    const otherQuery = Object.keys(cleanedParams)
      .map((key) => {
        const value = cleanedParams[key];
        if (Array.isArray(value)) {
          return value
            .map(
              (item) => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`
            )
            .join("&");
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .join("&");

    const queryString = [
      campaignQuery,
      statusQuery,
      indicationQuery,
      providerQuery,
      creativeTypeQuery,
      otherQuery,
    ]
      .filter(Boolean)
      .join("&");

    const response = await axiosClient.get(`ad-copies?${queryString}`);

    return response.data;
  } catch (error: any) {
    if (error.name === "CanceledError" || error.name === "AbortError") {
      console.warn("Request canceled");
    } else {
      throw error;
    }
  }
};

export const DropdownListService = async () => {
  try {
    const response = await axiosClient.get(`dropdown/list`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const AdCopiesMetricListDropdownService = async () => {
  try {
    const response = await axiosClient.get(`/ad-copies/metric-list`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const AdCopiesMetricsDetailsService = async (params: {
  ad_details_id: number;
}) => {
  try {
    const response = await axiosClient.get(
      `ad-copies/show?ad_details_id=${params.ad_details_id}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const AdCopiesInsightDetailsService = async (params: {
  ad_details_id: number;
}) => {
  try {
    const response = await axiosClient.get(
      `ad-copies/details?ad_details_id=${params.ad_details_id}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const PostAdCopiesMetricsService = async (formData: FormData) => {
  try {
    const response = await axiosClient.post(
      `ad-copies/save/metrics`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
